import { render, staticRenderFns } from "./ReceptionMail.vue?vue&type=template&id=18e66e86&scoped=true"
import script from "./ReceptionMail.vue?vue&type=script&lang=js"
export * from "./ReceptionMail.vue?vue&type=script&lang=js"
import style0 from "./ReceptionMail.vue?vue&type=style&index=0&id=18e66e86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e66e86",
  null
  
)

export default component.exports